module.exports = __webpack_public_path__ + "00f32672b5bceded38bc8b2deae2fe2a.pdf";